import { render } from "./StocksView.vue?vue&type=template&id=8a951d74&scoped=true"
import script from "./StocksView.vue?vue&type=script&lang=js"
export * from "./StocksView.vue?vue&type=script&lang=js"

import "./StocksView.vue?vue&type=style&index=0&id=8a951d74&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a951d74"]])

export default __exports__